import {useSalesMarketingApi} from "./useSalesMarketingApi";

export const useLookupActions = () => {
    const {GET} = useSalesMarketingApi();

    async function getRatePlanInfoByProductCode(productCode: string,controlSetFalseLoading?:boolean ) {
        return await GET("sm/lookup/rate-plan/" + productCode, true,controlSetFalseLoading);

    }

    async function getCategoriesBySegmentCode(segmentCode?: string) {
        let params = {segmentCode: segmentCode}
        let data = await GET("sm/lookup/category-code", false,{params: params});
        return data?.result["category-code"];
    }

    return {
        getRatePlanInfoByProductCode,
        getCategoriesBySegmentCode
    };
}